import React from 'react';
import queryString from 'query-string';
import AppBar from '@material-ui/core/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { db } from '../settings/firebase';
import Footer from '../components/Footer';
import PostBody from '../components/PostBody';
import NoImg from '../img/noimg.jpg';
import './Home.css';

const cardContents = [
  {
    docId: "test0",
    title: "",
    description: "",
    comment: "",
    recommender: "",
    avatarUrl: NoImg,
    thumbnail: NoImg,
  }
]

class ItemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {list: cardContents, tab: props.tab, query: queryString.parse(window.location.search)};
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  _isMounted = false; //unmountを判断（ローディング判定用）

  // Firestoreからデータ一覧を取得する
  async componentDidMount() {
    let articlesDb = db.collection("items");
    if(this.state.tab !== "") {
      articlesDb = await articlesDb.where("ganre", "==", this.state.tab)
    }
    const articlesSnapshot = await articlesDb.orderBy('createdAt', 'desc').get()
    let usershot = [];
    await db.collection("users").get().then((snapshot) => {
      usershot = snapshot;
    })
    const items = [];
    articlesSnapshot.forEach(doc => {
      let data = doc.data();
      let add = true
      if(this.state.query.q && this.state.query.q !== "") {
        if (data.title.indexOf(this.state.query.q) === -1 
          && data.urlTitle.indexOf(this.state.query.q) === -1
          && data.comment.indexOf(this.state.query.q) === -1
          && data.description.indexOf(this.state.query.q) === -1) {
          add = false;
        }
      }
      // console.log(data)
      if (add) {
        data.docId = doc.id;
        if(data.thumbnail.length === 0) {
          data.thumbnail = NoImg;
        }
        usershot.forEach(userdoc => {
          if(userdoc.id === data.recommender) {
            data.avatarUrl = userdoc.data().avatarUrl;
            data.username = userdoc.data().name;
            data.displayid = userdoc.data().displayid;
          }
        });
        items.push(data);
      }
    });

    this._isMounted = true;
    this.setState({ list: items });
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  render() {
    let list = this.state.list;
    let listItems = []
    for ( const itemdata of list) {
      listItems.push(<PostBody key={itemdata.docId} data={itemdata} />)
    }
    // console.log(list);
    // console.log(this.state.tab)
    return (
      <div style={{display: "flex", flexWrap: "wrap"}}>
        {listItems}
      </div>
    )
  }
}

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {tabValue: 0};
    this.changeTab = this.changeTab.bind(this);
    this.changeIndex = this.changeIndex.bind(this);
  }

  changeTab(e, newValue) {
    this.setState({tabValue: newValue});
  }

  changeIndex(index) {
    this.setState({tabValue: index});
  }

  render() {
    return (
      <>
        <AppBar position="static" className={"homeBar"}>
          <Tabs
            value={this.state.tabValue}
            onChange={this.changeTab}
            className={"homeBar"}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="tabs label"
          >
            <Tab label="新着" id="tab00-label" aria-controls="tab00" className={"homeBarText"} />
            <Tab label="YouTube" id="tab01-label" aria-controls="tab01" className={"homeBarText"} />
            <Tab label="最近買ってよかったもの" id="tab02-label" aria-controls="tab02" className={"homeBarText"} />
            <Tab label="なんでも" id="tab03-label" aria-controls="tab03" className={"homeBarText"} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          index={this.state.tabValue}
          onChangeIndex={this.changeIndex}
        >
          <div role="tabpanel" id="tab00" index={0} aria-labelledby="tab00-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab="" />
          </div>
          <div role="tabpanel" id="tab00" index={1} aria-labelledby="tab01-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab="youtube" />
          </div>
          <div role="tabpanel" id="tab01" index={2} aria-labelledby="tab02-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab="recently" />
          </div>
          <div role="tabpanel" id="tab02" index={3} aria-labelledby="tab03-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab="free" />
          </div>
        </SwipeableViews>
        <Footer page="" />
      </>
    )
  }
}

export default Home